<template>
	<V2Layout><div class="v2-page-wrap">
		<OriginalComponent />
	</div></V2Layout>
</template>

<script>
import V2Layout from '@/layouts/V2Layout';
import OriginalComponent from '@/pages/error/500-internal-server-error.vue';

export default {
	name: 'V2Error500',
	components: { V2Layout, OriginalComponent },
};
</script>

<style lang="sass" scoped>
@import '~@/assets/styles/v2-page-overrides'
</style>
